/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { RadioButtonGroup as RadioButton } from '@vds/radio-buttons';

const VdsRadioButton = (props) => (
  <RadioButton {...props} />
);

VdsRadioButton.defaultProps = {
  error: false,
  onChange: () => {},
};

VdsRadioButton.propTypes = {
  defaultValue: PropTypes.string || PropTypes.number,
  error: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.array,
  children: PropTypes.any,
};

export default VdsRadioButton;
